module.exports = __webpack_public_path__ + "img/1_of_Spades.svg.f78181ef.png";